"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const warn_png_1 = __importDefault(require("../../assets/img/warn.png"));
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-176a54c2"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "maxContent" };
const _hoisted_2 = { class: "searchContent" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("h4", null, "溯源案例分析", -1));
const _hoisted_4 = { class: "analyse" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "icon" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("img", {
        src: warn_png_1.default,
        alt: ""
    })
], -1));
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "info" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "title" }, "市场故障率分析"),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "content" }, "BI系统中有丰富的图表数据进行市场故障率的专业分析")
], -1));
const _hoisted_7 = [
    _hoisted_5,
    _hoisted_6
];
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "more" }, " 更多敬请期待... ", -1));
const vue_router_1 = require("vue-router");
const index_1 = require("../../service/index");
const vue_3 = require("vue");
const ant_design_vue_1 = require("ant-design-vue");
const index_2 = require("../../utils/index");
exports.default = (0, vue_1.defineComponent)({
    __name: 'index',
    setup(__props) {
        const [messageApi, contextHolder] = ant_design_vue_1.message.useMessage();
        const router = (0, vue_router_1.useRouter)();
        const productionOrDevice = (0, vue_3.ref)(0); //0表示产品查询，1表示器件查询
        const searchKeywords = (params) => __awaiter(this, void 0, void 0, function* () {
            const { keywords, callback } = params, otherParams = __rest(params, ["keywords", "callback"]);
            const response = yield (0, index_1.searchSnByKeywords)(Object.assign({ keywords }, otherParams));
            const data = (response.data || []).map(item => (Object.assign({ label: item.suyuanqijiansn, value: item.suyuanqijiansn }, item)));
            callback(data);
        });
        //普通查询
        const searchCode = (params) => {
            const { SN, stakeQR: stakeQRCode, deviceSN, selectOption } = params;
            if (productionOrDevice.value === 0) {
                if (SN || stakeQRCode) {
                    router.push({
                        path: '/productionInfo',
                        query: {
                            chengpinsnma: SN,
                            stakeQRCode,
                        }
                    });
                }
                else {
                    messageApi.error('请先搜索并在下拉框选择SN码或桩二维码');
                }
            }
            else {
                if (deviceSN) {
                    router.push({
                        path: '/deviceInfo',
                        query: {
                            suyuanqijiansn: selectOption.suyuanqijiansn,
                            chengpinsnma: selectOption.chengpinsnma,
                        }
                    });
                }
                else {
                    messageApi.error('请先搜索并在下拉框选择溯源器件SN码');
                }
            }
        };
        //高级查询
        const advancedQuery = (values) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            let res = null;
            if (productionOrDevice.value === 0) {
                res = yield (0, index_1.queryByCondition)(values);
                if (((_b = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.list) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                    if (values === null || values === void 0 ? void 0 : values.chanpinsnma) {
                        router.push({
                            path: '/productionInfo',
                            query: {
                                chengpinsnma: values.chanpinsnma
                            }
                        });
                    }
                    else {
                        router.push({
                            name: 'productionInfoList',
                            state: {
                                params: values
                            }
                        });
                    }
                }
                else {
                    messageApi.info(`未能查询到指定条件的充电桩产品`);
                }
            }
            else {
                res = yield (0, index_1.syqjQueryByCondition)(values);
                if (((_d = (_c = res === null || res === void 0 ? void 0 : res.data) === null || _c === void 0 ? void 0 : _c.list) === null || _d === void 0 ? void 0 : _d.length) > 0) {
                    if (values === null || values === void 0 ? void 0 : values.suyuanqijiansn) {
                        router.push({
                            path: '/deviceInfo',
                            query: {
                                chengpinsnma: encodeURI(values.chengpinsnma || ""),
                                suyuanqijiansn: encodeURI(values.suyuanqijiansn || ""),
                            }
                        });
                    }
                    else {
                        router.push({
                            name: 'deviceInfoList',
                            state: {
                                params: values
                            }
                        });
                    }
                }
                else {
                    messageApi.info(`未能查询到指定条件的器件`);
                }
            }
        });
        const toBI = () => {
            window.open("https://xxcd.guandatacloud.com/home/web-app/u3942c0b4b4044d1ca501a39?pgId=d82b83465ca68401b9742a3a&id=diSQcYmBGN", '_blank');
        };
        (0, vue_3.onMounted)(() => __awaiter(this, void 0, void 0, function* () {
            const res = yield (0, index_1.searchSN)("");
            if (res.code === 999) {
                messageApi.error(res.msg + '，3秒后将返回登录页面...');
                setTimeout(() => {
                    (0, index_2.logOut)();
                }, 3000);
            }
        }));
        return (_ctx, _cache) => {
            const _component_HeaderNew = (0, vue_2.resolveComponent)("HeaderNew");
            const _component_SearchPile = (0, vue_2.resolveComponent)("SearchPile");
            const _component_a_col = (0, vue_2.resolveComponent)("a-col");
            const _component_a_row = (0, vue_2.resolveComponent)("a-row");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createVNode)(_component_HeaderNew),
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("span", {
                        onClick: _cache[0] || (_cache[0] = () => { productionOrDevice.value = 0; }),
                        style: (0, vue_2.normalizeStyle)({ color: productionOrDevice.value === 0 ? '#f08300' : '#000000' })
                    }, "产品查询", 4),
                    (0, vue_2.createElementVNode)("span", {
                        onClick: _cache[1] || (_cache[1] = () => { productionOrDevice.value = 1; }),
                        style: (0, vue_2.normalizeStyle)({ color: productionOrDevice.value === 1 ? '#f08300' : '#000000' })
                    }, "器件查询", 4),
                    (0, vue_2.createVNode)(_component_SearchPile, {
                        class: "searchPile",
                        onSearchCode: searchCode,
                        onAdvancedQuery: advancedQuery,
                        onSearchKeywords: searchKeywords,
                        customSearchMethod: true,
                        productionOrDevice: productionOrDevice.value,
                        openAdvancedQuery: true
                    }, null, 8, ["productionOrDevice"]),
                    _hoisted_3,
                    (0, vue_2.createElementVNode)("div", _hoisted_4, [
                        (0, vue_2.createVNode)(_component_a_row, { gutter: [16, 24] }, {
                            default: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createVNode)(_component_a_col, { class: "gutter-row" }, {
                                    default: (0, vue_2.withCtx)(() => [
                                        (0, vue_2.createElementVNode)("div", {
                                            class: "card",
                                            onClick: toBI
                                        }, _hoisted_7)
                                    ]),
                                    _: 1
                                }),
                                (0, vue_2.createVNode)(_component_a_col, { class: "gutter-row" }, {
                                    default: (0, vue_2.withCtx)(() => [
                                        _hoisted_8
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        })
                    ])
                ]),
                (0, vue_2.createVNode)((0, vue_2.unref)(contextHolder))
            ]));
        };
    }
});
